export default __webpack_public_path__ + "static/media/hm-hero-mobile.26eadddb.mp4";